export default "__VITE_ASSET__C6PMr9xq__"